import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { TSettingsField, TSettingsFormData } from 'src/@types';

/*
 * 모든 회사 정보 중 필요한 언어에 해당하는 회사 정보(Settings)를 반환하는 훅
 * @param langCd 언어 코드
 * @returns 회사의 모든 언어별 리스트 (companyInfos)
 * @returns langCd에 해당하는 회사 정보 인덱스 (index)
 * @returnslangCd에 해당하는 회사 정보 (selectedCompanyInfo)
 */

export const useCompanyInfoByLanguage = (langCd: string) => {
  const { watch } = useFormContext<TSettingsFormData>();

  const companyInfos = watch('companyInfos');

  const index = useMemo(
    () => companyInfos?.findIndex((info) => info.langCd === langCd) ?? -1,
    [companyInfos, langCd],
  );

  const selectedCompanyInfo = useMemo(
    () => companyInfos?.find((info: TSettingsField) => info.langCd === langCd),
    [companyInfos, langCd],
  );

  return {
    companyInfos,
    index,
    selectedCompanyInfo,
  };
};
